import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MetaService } from '@app/core/services/meta.service';
import { NavItem } from '@app/interfaces/nav-item';
import { NavComponent } from '@app/layout/nav/nav.component';

@Component({
  selector: 'app-about-page',
  templateUrl: './about.page.html',
  styleUrls: ['./about.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavComponent],
})
export class AboutPage implements OnInit {
  constructor(private metaService: MetaService) {}

  protected navItems: NavItem[] = [{ label: 'About' }];

  ngOnInit(): void {
    const metadata = {
      title: 'ImageBase.pro – Your Source for High-Quality Stock Images',
      description:
        'Learn more about ImageBase.pro, a leading platform offering high-resolution stock images for creative professionals, businesses, and marketers.',
      keywords:
        'about ImageBase.pro, stock images platform, high-quality photos, stock photography service, professional images, commercial photos',
    };

    this.metaService.setMetadata(metadata);
  }
}
